module.exports = __webpack_public_path__ + "static/img/40.fd1d5d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/40.png
// module id = emoX
// module chunks = 1